<template>
    <div class="home-page">
		<Header></Header>
		<div class="mission" v-if="!notFound">
      <div class="mission-content">
        <div class="luckyDraw-list">
          <div class="draw-prize">
            {{$t('drawPrize')}}
          </div>
          <div class="mt100 ac">
            <img src="../../static/images/grand-prizes.png">
          </div>
          <div class="prize-c flex">
            <div class="prize-one">
              <div class="img">
                <img src="../../static/images/prize-img.png" />
              </div>
              <!-- <div class="prize-name">
                <strong class="fs40">"First Prize"</strong>                {{list[0].remark}}
              </div> -->
            </div>
            <div class="prize-two">
              <div class="img">
                <img src="../../static/images/prize-img.png" />
              </div>
              <!-- <div class="prize-name">
                <strong>"Second Prize"</strong>
                {{list[1].remark}}
              </div> -->
            </div>
          </div>
          <div class="point-history lucky-li mt20" v-if="list.length>0">
            <div class="point-t ac disflex">
              <span class="point-one1">{{$t('Name')}}</span>
              <span class="point-one2">{{$t('Prize')}}</span>
            </div>
            <div class="point-c">
              <div class="point-li ac disflex" v-for="(item,index) in list">
                <span class="point-one1">{{item.nickname}}</span>
                <span class="point-one2">{{item.remark}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
		</div>
	</div>
</template>
<script>
import Header from '../components/header'
export default {
    components:{
		Header
    },
    data() {

    return {
			notFound:false,
			list:[],
			page_id:1,
			page_size:10,
			isShow:'All',

		}
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
		this.getHome();
	},
    methods: {
      back(){
        this.$router.push({path:'/'})
      },
      getHome(){
        let that =this;
       // / that.$parent.loadModal(true);
        that.$api.get('/api/lucky/list',null,r =>{
          that.$parent.returnCode(r,function(){
            that.$parent.loadModal(false);
            if(r.data.length>0){
              that.list = r.data
            }else{
              that.isShow = false;
          }
        });
      })
    },
    getList(item){
      this.isShow = item
    },
		getMore(){
			let that = this;
			if(that.isShow){
				that.page_id++;
				that.getHome();
			}else{
				//that.$utils.alertText(that.$t('noMore'));
			}
		},
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/luckyDraw.vue